import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';
import { List } from '@codex/basics';
import MoreInfoButton from './MoreInfoButton';
import InformationTooltip from './InformationTooltip';
import SimpleParser from '../../helpers/SimpleParser';

const StyledMoreDetails = styled.div`
  width: 100%;
  height: auto;
  transition: margin-top .4s linear, max-height .4s cubic-bezier(1,0,0,1);
  margin-top: ${(props) => (
    props.isToggled ? '24px' : '0px'
  )};
  max-height: ${(props) => (
    props.isToggled ? '160px' : '0px'
  )};
  overflow-y: hidden;
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding-top: 10px;
    margin-bottom: ${(props) => (props.isToggled ? '10px' : '0px')};
    order: 1;
  }  
`;

const StyledHeading = styled.div`
  font-family: CurrysSans;
  font-size: 14px;
  color: ${(props) => props.theme.colors.neutral.currysBlack};
  padding-bottom: 15px;
`;

const StyledItemWrapper = styled.span`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const StyledListIcon = styled(Icon)`
  width: 22px;
  height: 22px;
  margin-top: -6px;
  margin-right: 5px;
  
  svg path:last-child {
    stroke: none;
    fill: ${(props) => props.theme.colors.semantic.green};
  }
  
  > svg {
    > g {
      /* Hide border of the icon */
      path:nth-child(1) {
        display: none
      }
    }
  }
`;

const StyledListText = styled.span`
  font-family: CurrysSans;
  font-size: 14px;
  color: ${(props) => props.theme.colors.neutral.currysBlack};

  @media ${(props) => props.theme.breakpoints.mobile} {
    font-size: 12px;
  }
`;

const MoreDetails = ({
  html, type, isPopoverDisplayed, isToggled, moreInfoText, tooltipHtml, handlePopoverDisplay, displayError
}) => {
  const [heading, items] = SimpleParser.parse(html, type);

  return (
    <StyledMoreDetails isToggled={isToggled}>
      <StyledHeading>{heading}</StyledHeading>
      <List items={items}>
        {(item, index, ItemWrapper) => {
          const isLastItem = index + 1 === items.length;
          return (
            <ItemWrapper key={index}>
              <StyledItemWrapper>
                <span>
                  <StyledListIcon icon={'tick'} />
                  <StyledListText>{item}</StyledListText>
                </span>
                <MoreInfoButton
                  isDisplayed={isLastItem}
                  onClick={() => handlePopoverDisplay(!isPopoverDisplayed)}
                  moreInfoText={moreInfoText}
                />
              </StyledItemWrapper>
              <InformationTooltip
                onCloseClick={() => handlePopoverDisplay(false)}
                tooltipHtml={tooltipHtml}
                isDisplayed={isPopoverDisplayed && isToggled && isLastItem}
                displayError={displayError}
              />
            </ItemWrapper>
          );
        }}
      </List>
    </StyledMoreDetails>
  );
};

MoreDetails.propTypes = {
  html: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isPopoverDisplayed: PropTypes.bool.isRequired,
  isToggled: PropTypes.bool.isRequired,
  moreInfoText: PropTypes.string.isRequired,
  tooltipHtml: PropTypes.string.isRequired,
  handlePopoverDisplay: PropTypes.func.isRequired,
  displayError: PropTypes.bool.isRequired
};

export default MoreDetails;
